var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[[_c('list-group',{attrs:{"title":'登録・ログインする'}},[_c('list-item',{attrs:{"spanText":'Q. ',"text":'SMS認証コードが届かない',"urlName":'Help30'}}),_vm._v(" "),_c('list-item',{attrs:{"spanText":'Q. ',"text":'WeRUNアプリが使えない機種はありますか？',"urlName":'Help1'}})],1)]],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef0f540c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HelpCategory51.vue
// module id = fVxc
// module chunks = 0